export const LAYOUT_TOGGLE_ACTION = 'LAYOUT_TOGGLE_ACTION';
export const LAYOUT_RENAME_ACTION = 'LAYOUT_RENAME_ACTION';
export const LAYOUT_SCREEN_SIZE = 'LAYOUT_SCREEN_SIZE';

export const toggleLeftMenu  = () => ({
  type: LAYOUT_TOGGLE_ACTION
});

export const provideScreenSize = (size) => ({
  type: LAYOUT_SCREEN_SIZE,
  size
});

export const setHeaderTitle = (title = 'Back office') => ({
  type: LAYOUT_RENAME_ACTION,
  title
});



// WEBPACK FOOTER //
// ./src/actions/layout.js